import { createSlice } from '@reduxjs/toolkit'
import { initialSelectedFilters } from 'src/constants/componentConstants/dataManagement/dataManagement.constants'
import { getFiltersDataManagementAsync } from 'src/services/dataManagement/dataManagement.services'

const initialState = {
  selected: initialSelectedFilters,
  options: {
    vendorId: [],
    vendorName: [],
    vendorType: [],
    country: [],
    l1: [],
    l2: [],
    l3: [],
    productType: [],
    htsCode: [],
    uploadedBy: [],
    uploadedTo: null,
    uploadedFrom: null,
    skuPrimaryId: [],
    poCurrency: [],
    ltmSpend: { max_ltm_spend: 0, min_ltm_spend: 0 },
    ConfidenceCount: {},
    fetchOnlyTaxonomyFilter: false,
  },
  loading: false,
}

export const selectedFiltersSlice = createSlice({
  name: 'data-management-filters-slice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getFiltersDataManagementAsync.pending, (state) => {
        state.loading = true
      })
      .addCase(getFiltersDataManagementAsync.fulfilled, (state, action) => {
        const {
          vendorId,
          vendorName,
          vendorType,
          country,
          l1,
          l2,
          l3,
          productType,
          htsCode,
          uploadedBy,
          skuPrimaryId,
          poCurrency,
          dateRange,
          ltmSpend,
          ConfidenceCount,
          fetchOnlyTaxonomyFilter,
        } = action.payload.data
        state.options = fetchOnlyTaxonomyFilter
          ? {
              ...state.options,
              l1: l1 ?? [],
              l2: l2 ?? [],
              l3: l3 ?? [],
              fetchOnlyTaxonomyFilter,
            }
          : {
              vendorId: vendorId ?? [],
              vendorName: vendorName ?? [],
              vendorType: vendorType ?? [],
              country: country ?? [],
              l1: l1 ?? [],
              l2: l2 ?? [],
              l3: l3 ?? [],
              productType: productType ?? [],
              htsCode: htsCode ?? [],
              uploadedFrom: dateRange?.min_date ?? null,
              uploadedTo: dateRange?.max_date ?? null,
              uploadedBy: uploadedBy ?? [],
              skuPrimaryId: skuPrimaryId ?? [],
              poCurrency: poCurrency ?? [],
              ltmSpend: ltmSpend ?? { max_ltm_spend: 0, min_ltm_spend: 0 },
              ConfidenceCount: ConfidenceCount ?? {},
              fetchOnlyTaxonomyFilter,
            }
        state.loading = false
      })
      .addCase(getFiltersDataManagementAsync.rejected, (state) => {
        state.loading = false
        state.options = initialState.options
      })
  },
  reducers: {
    setAppliedFilterSection: (state, action) => {
      state.selected = { ...action.payload }
    },
    setFiltersOptions: (state, action) => {
      state.options = { ...action.payload }
    },
    resetAppliedFilterSection: (state) => {
      state.selected = initialSelectedFilters
    },
  },
})

export const { setAppliedFilterSection, resetAppliedFilterSection, setFiltersOptions } =
  selectedFiltersSlice.actions

export default selectedFiltersSlice.reducer
